import { NoticeStatus } from "../../../../../components";
import { IconSprite } from "../../../../../components/ui/IconSprite/IconSprite";

import { BoxIcon, BoxText, Text, Title, Wrapper } from "./TileCard.styled";

export const TileCard = ({ icon, title, description, status }) => {
  return (
    <Wrapper>
      <BoxIcon>
        <IconSprite tag={icon} width="63" height="63" />
        <NoticeStatus status={status} />
      </BoxIcon>
      <BoxText>
        <Title>{title}</Title>
        <Text>{description}</Text>
      </BoxText>
    </Wrapper>
  );
};
